export default __webpack_public_path__ + "static/media/login-bg-25.37496648.jpg";